/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import homeLinksTemplate from './home-links.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function HomeLinksRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.links', {
            url: '/home',
            module: 'private',
            auth: types.allAuthorities,
            views: {
                "content@home": {
                    templateUrl: homeLinksTemplate,
                    controllerAs: 'vm',
                    controller: 'HomeLinksController'
                }
            },
            data: {
                pageTitle: 'home.home'
            },
            ncyBreadcrumb: {
                label: '{"icon": "home", "label": "home.home"}',
                icon: 'home'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/home/home-links.routes.js